import React, { lazy, Suspense } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { Loading } from '@com-components/'

const Dashboard = lazy(() => import('@pages/dashboard'))
const Manager = lazy(() => import('@pages/manager'))
const Policy = lazy(() => import('@pages/policy'))
const Monitor = lazy(() => import('@pages/monitor'))

const Routes = () => (
  <Suspense fallback={<Loading />}>
    <Switch>
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/manager" component={Manager} />
      <Route path="/policy" component={Policy} />
      <Route path="/monitor" component={Monitor} />
      <Redirect to="/dashboard" />
    </Switch>
  </Suspense>
)

export default Routes
